import React from 'react';

const AuthFooter: React.FC = () => {
    return (
        <>
            {/* standard index footer */}
            <footer className="adminuiux-footer mt-auto py-2">
                <div className="container-fluid text-center">
                    <span className="small">Copyright @2025, <a href="https://adminuiux.com" target="_blank" className="" rel="noreferrer">by DevUIUX</a> on Earth ❤️ </span>
                </div>
            </footer>

            {/* theming action */}
            <div className="position-fixed bottom-0 end-0 m-3 z-index-5 pb-ios" id="fixedbuttons">
                <button className="btn btn-square btn-theme rounded-circle" type="button" data-bs-toggle="offcanvas" data-bs-target="#theming" aria-controls="theming"><i className="bi bi-palette"></i></button>
                <br />
                <button className="btn btn-theme btn-square mt-2 d-none rounded-circle" id="backtotop"><i className="bi bi-arrow-up"></i></button>
            </div>
        </>
    )
};

export default AuthFooter;
